import course1_1 from "../resources/images/projectphotos2025/course1/Picture1.jpg";
import course1_2 from "../resources/images/projectphotos2025/course1/Picture2.png";
import course1_3 from "../resources/images/projectphotos2025/course1/Picture3.png";
import course1_4 from "../resources/images/projectphotos2025/course1/Picture4.png";
import course1_5 from "../resources/images/projectphotos2025/course1/Picture5.png";

import course2_1 from "../resources/images/projectphotos2025/course2/Picture1.png";
import course2_2 from "../resources/images/projectphotos2025/course2/Picture2.png";
import course2_3 from "../resources/images/projectphotos2025/course2/Picture3.png";
import course2_4 from "../resources/images/projectphotos2025/course2/Picture4.jpg";

import course3_1 from "../resources/images/projectphotos2025/course3/Picture1.png";
import course3_2 from "../resources/images/projectphotos2025/course3/Picture2.png";
import course3_3 from "../resources/images/projectphotos2025/course3/Picture3.jpg";
import course3_4 from "../resources/images/projectphotos2025/course3/Picture4.jpg";
import course3_5 from "../resources/images/projectphotos2025/course3/Picture5.png";
import course3_6 from "../resources/images/projectphotos2025/course3/Picture6.png";
import course3_7 from "../resources/images/projectphotos2025/course3/Picture7.png";

import course4_1 from "../resources/images/projectphotos2025/course4/Picture1.jpg";
import course4_2 from "../resources/images/projectphotos2025/course4/Picture2.jpg";
import course4_3 from "../resources/images/projectphotos2025/course4/Picture3.jpg";
import course4_4 from "../resources/images/projectphotos2025/course4/Picture4.jpg";

const course1Images = [course1_1, course1_2, course1_3, course1_4, course1_5];
const course2Images = [course2_1, course2_2, course2_3, course2_4];
const course3Images = [course3_1, course3_2, course3_3, course3_4, course3_5, course3_6, course3_7];
const course4Images = [course4_1, course4_2, course4_3, course4_4];

export const projects2025Data = [
  {
    id: 1,
    title: "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» - продвинутый уровень",
    year: "2025",
    aim: "Курсы повышения квалификации педагогов среднего образования Алматинской, Карагандинской областях и в области Жетісу были направлены на развитие предметных, методических и цифровых компетенций через освоение интерактивных стратегий обучения, подходов PISA к формированию функциональной и читательской грамотности, эффективных моделей оценивания, а также использование цифровых технологий и искусственного интеллекта в образовательном процессе",
    participantCategory: "учителя начальных классов, казахского языка, английского языка, географии, математики, информатики, физики, истории, биологии, химии, русского языка",
    totalParticipants: 9022,
    imageUrl: null,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Места проведения и результаты"
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Область Жетісу",
            items: [
              "Период обучения: 26.03 - 01.04.2025 г.",
              "Количество слушателей: 997 чел.",
              "Результаты обучения: Качество успеваемости - 90%"
            ]
          },
          {
            title: "Карагандинская область",
            items: [
              "Период обучения: 26.05 - 30.05.2025 г.",
              "Количество слушателей: 2 825 чел.",
              "Результаты обучения: Качество успеваемости - 91%"
            ]
          },
          {
            title: "Алматинская область",
            items: [
              "Период обучения: 26.03 - 13.06.2025г.",
              "Количество слушателей: 5 200 чел.",
              "Результаты обучения: Качество успеваемости - 96%"
            ]
          }
        ]
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: course1Images
      }
    ]
  },
  {
    id: 2,
    title: "Курсы в рамках проекта «Развитие потенциала малокомплектных школ (МКШ)»",
    year: "2025",
    aim: "Курсы повышения квалификации были направлены на развитие педагогических, предметных и цифровых компетенций педагогов малокомплектных школ Акмолинской, Костанайской областей и области Абай с акцентом на современные методики, цифровые, ИИ-инструменты и ценностно-ориентированную образовательную среду.",
    participantCategory: "руководители и педагоги организаций среднего образования по математике, биологии, английскому языку, географии, информатике, физике, химии",
    totalParticipants: 3335,
    imageUrl: null,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Места проведения и результаты"
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Костанайская область",
            items: [
              "Период обучения: 16.06 - 15.08.2025 г.",
              "Количество слушателей: 1 200 чел.",
              "Результаты обучения: Качество успеваемости - 93%"
            ]
          },
          {
            title: "Акмолинская область",
            items: [
              "Период обучения: 16.06 - 15.08.2025 г.",
              "Количество слушателей: 1 050 чел.",
              "Результаты обучения: Качество успеваемости - 86%"
            ]
          },
          {
            title: "область Абай",
            items: [
              "Период обучения: 28.10 - 14.11.2025г.",
              "Количество слушателей: 1 085 чел.",
              "Результаты обучения: Качество успеваемости - 96%"
            ]
          }
        ]
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: course2Images
      }
    ]
  },
  {
    id: 3,
    title: "Курсы в рамках проекта «Сельская школа: равные возможности (ФХБ и МКШ)»",
    year: "2025",
    aim: "Курсы повышения квалификации в Кызылординской и Западно-Казахстанской областях были направлены на совершенствование предметных, цифровых, управленческих и педагогических компетенций педагогов и администрации школ",
    participantCategory: "педагоги и администрация школ",
    totalParticipants: 3743,
    imageUrl: null,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Места проведения и результаты"
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Кызылординская область",
            items: [
              "Период обучения: 03.11 - 28.11.2025г",
              "Количество слушателей: 1 862 чел.",
              "Результаты обучения: Качество успеваемости - 90%"
            ]
          },
          {
            title: "Западно-Казахстанская область",
            items: [
              "Период обучения: 17.11 - 19.12.2025 г.",
              "Количество слушателей: 1 881 чел.",
              "Результаты обучения: Качество успеваемости - 92%"
            ]
          }
        ]
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: course3Images
      }
    ]
  },
  {
    id: 4,
    title: "Курсы повышения квалификации педагогов государственных организаций среднего образования области Абай",
    year: "2025",
    aim: "совершенствование предметных и профессиональных компетенций педагогов через изучение современных образовательных технологий и методик, соответствующих требованиям государственных общеобязательных стандартов (ГОСО), с акцентом на межпредметную интеграцию, развитие функциональной грамотности, критического мышления, а также практических и исследовательских навыков у обучающихся, что позволит эффективно решать реальные жизненные задачи и адаптироваться к изменениям динамично меняющегося мира",
    participantCategory: "педагоги государственных организаций среднего образования",
    totalParticipants: 1178,
    city: "область Абай",
    date: "02.09 - 31.10.2025 г.",
    imageUrl: null,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Результаты обучения"
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "96%"
      },
      {
        type: "heading",
        level: 2,
        text: "Направления обучения"
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Основные направления",
            items: [
              "методика и практика преподавания языка программирования Python",
              "инновации и современные технологии в обучении химии",
              "развитие естественнонаучной грамотности на уроках биологии",
              "развитие рецептивных и продуктивных навыков в преподавании и обучении английскому языку",
              "проектная деятельность в учебном предмете «Информатика»",
              "инновационные технологии в обучении английскому языку",
              "практикоориентированное обучение физике на основе межпредметной интеграции",
              "реализация ценностно-ориентированного подхода в начальной школе",
              "исследовательская и проектная деятельность обучающихся начальной школы",
              "интеграция национальных ценностей через содержание предмета «Музыка»",
              "преподавание математики: современные тенденции и методы"
            ]
          }
        ]
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: course4Images
      }
    ]
  }
];

projects2025Data.forEach(project => {
  const gallerySection = project.contentSections.find(section => section.type === 'gallery');
  if (gallerySection && gallerySection.images && gallerySection.images.length > 0) {
    project.imageUrl = gallerySection.images[0];
  } else {
    project.imageUrl = "/EduMax.svg";
  }
});
